/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Portal API Gateway
 * OpenAPI spec version: 2.0.0
 */

/**
 * A domain associated with an alert
 */
export type AlertTag = (typeof AlertTag)[keyof typeof AlertTag]

export const AlertTag = {
  home: "home",
  tariff: "tariff",
  meterReading: "meterReading",
} as const
